/**
 * Logo.jsx
 * Reads logoUrl from localStorage (set by admin upload).
 * Falls back to text initials if no image.
 * Size: sm | md | lg | xl
 * showTagline: bool
 */
import React, { useState } from 'react';
import './Logo.css';

const LOGO_KEY = 'drusshti_logo_url';

export const getLogoUrl = () => localStorage.getItem(LOGO_KEY);
export const setLogoUrl = (url) => {
  if (url) localStorage.setItem(LOGO_KEY, url);
  else localStorage.removeItem(LOGO_KEY);
};

const Logo = ({ size = 'md', showTagline = false, linkTo = '/' }) => {
  const [imgError, setImgError] = useState(false);
  const logoUrl = getLogoUrl();
  const showImg = logoUrl && !imgError;

  return (
    <a href={linkTo} className={`logo-wrap logo-${size}`} onClick={e => e.preventDefault()}>
      <div className="logo-img-wrap">
        {showImg
          ? <img src={logoUrl} alt="Drusshti" className="logo-img" onError={() => setImgError(true)} />
          : <div className="logo-fallback">D</div>
        }
      </div>
      <div className="logo-text-wrap">
        <span className="logo-name">DRUSSHTI</span>
        {showTagline && <span className="logo-tagline">Managing Services the Smarter Way</span>}
      </div>
    </a>
  );
};

export default Logo;
